import { render, staticRenderFns } from "./ChoosePart.vue?vue&type=template&id=0ed75d9c&"
import script from "./ChoosePart.vue?vue&type=script&lang=js&"
export * from "./ChoosePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports